import { render, staticRenderFns } from "./YarnSelector.vue?vue&type=template&id=5a22f08d&"
import script from "./YarnSelector.vue?vue&type=script&lang=js&"
export * from "./YarnSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports